exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-column-wrapper[data-v-3b4b9efa]{width:100%;padding-bottom:10px}", ""]);

// exports
